import { MdCheck, MdClose } from "react-icons/md";
import Modal from "../Modal/Modal";
import { useTranslation } from "react-i18next";
import useModalsStore from "src/store/modalsStore";
import clsx from "clsx";
import TextInput from "../TextInput/TextInput";
import { useState } from "react";
import { ICON_SIZES } from "src/constants/icons";
import { EButtonKind } from "../Button/Button.types";

const EmailInviteModal: React.FC = () => {
  const { t } = useTranslation();
  const { setShowEmailInviteModal } = useModalsStore();
  const [email, setEmail] = useState<string>("");
  const [name, setName] = useState<string>("");

  return (
    <Modal
      onEscape={() => setShowEmailInviteModal(false)}
      className={clsx(["md:!max-w-[500px]", "md:!w-full"])}
    >
      <Modal.Header
        onClose={() => setShowEmailInviteModal(false)}
        title="Invitar por correo"
      />
      <Modal.Body>
        <div
          className={clsx(["flex", "w-full", "flex-col", "gap-4", "md:gap-6"])}
        >
          <p className={clsx(["text-sm", "md:text-sm"])}>
            Ingresa el nombre (opcional) y la dirección de correo electrónico de
            la persona que deseas invitar a eXpenser.net.
          </p>
          <TextInput
            type="text"
            onChange={(e: any) => setName(e?.target?.value)}
            placeholder="Nombre de la persona"
            label="Nombre"
            value={name}
          />
          <TextInput
            type="email"
            onChange={(e: any) => setEmail(e?.target?.value)}
            placeholder="Correo electrónico"
            label="Correo electrónico"
            value={email}
            required
            helpText="El correo se enviará utilizando la cuenta de Gmail que tienes vinculada"
          />
        </div>
      </Modal.Body>
      <Modal.Footer
        actions={[
          {
            icon: <MdCheck size={ICON_SIZES.MD} />,
            onClick: () => {},
            kind: EButtonKind.SAVE,
            text: t("Enviar"),
            disabled: !email,
          },
          {
            text: t("common:buttons.close"),
            onClick: () => setShowEmailInviteModal(false),
            kind: EButtonKind.NORMAL,
            icon: <MdClose size={ICON_SIZES.MD} />,
          },
        ]}
      />
    </Modal>
  );
};

export default EmailInviteModal;
